import React from 'react';
import HomepageFeaturesCards from "../homepageFeaturesCards/homepageFeaturesCards";
import HomepageData from '../../../data/bookingAndBeyondData/bookingAndBeyondData.json'

function HomepageFeaturesCardsWrapper() {
  return (
      <HomepageFeaturesCards
        content={HomepageData}
        title='Booking and beyond'
        description="Trafft isn’t just another online appointment booking app. It's a comprehensive solution for organizing your entire business."
      />
  );
}

export default HomepageFeaturesCardsWrapper;